
export default {
  OrderNo:"订单编号",
  OrderPayAmount: "支付金额",
  OrderPayType: "支付方式",
  OrderPayTime: "支付时间",
  OrderStatusSuccess: "支付成功",
  OrderStatusFailed: "支付失败",
}